import { base, baseODATA } from '../base';

export const potentialAudience = `${base}/PotentialAudience/PreviewContacts`;
export const savePotentialAudience = `${base}/PotentialAudience`;
export const getQueryODATA = `${baseODATA}/potentialaudiencesearchquery`;
